export default function useIbec(apiData: any) {
    if (apiData && apiData?.config?.modelType === 1) {
        return { isIbec: true }
    } else {
        return { isIbec: false }
    }
};